<template>
 <div class="login">
       <section class="hero">
         <div class="hero-body">
         <div class="container">
           <h1 class="title is-large is-primary is-bold">Login</h1>
           <h2 class="subtitle">Get in your account and start training</h2>
         </div>
         <section class="form">
           <div class="field">
            <div class="control">
              <input class="input" type="email" placeholder="EMAIL">
            </div>
          </div>
          <div class="control">
              <input class="input" type="password" placeholder="PASSWORD">
            </div>

            <p class="control is-small haveaccount">Don't have an account yet? 
              <span> 
              <router-link to="/register" class="is-large">Register</router-link>
              </span>
              </p>
         </section>
         </div>
       </section>
 </div>
</template>

<script>
// @ is an alias to /src

export default {
  name:'login'
}
</script>

<style lang="scss" scoped>
.login{
  background:url(../assets/body2.jpg);
  background-size:cover;
  height:fit-content;
  min-height:100vh;
}
a{
  color:hotpink;
  text-decoration:underline;
}
.hero{
 padding-top:15rem;
}
.title{
  color:#fff;
  font-size:3.5rem;
  font-family:monospace;
}
.title::after{
  content:'.';
  font-size:2.5rem;
  border-radius: 50%;
}
.subtitle{
  color:#fff;
  padding-top:1.5rem;
  font-size:1.5rem;
  font-weight:400;
  font-family: 'Times New Roman', Times, serif;
}
.form{
  margin-top: 2.5rem;
}
.haveaccount{
  color:#fff;
  margin-top: .75rem;
}
.input::placeholder{
  color:hsl(0, 0%, 0%);
  opacity:.5;
  text-align:center;
  font-family: sans-serif;
  font-size:.8rem;
}
</style>
